import { useEffect, useRef } from 'react';
import { useMediaQuery } from 'react-responsive';
import { BREAKPOINT_SIZES } from 'tradera/constants/breakpoints';

export const useMenuHeightFix = () => {
    const menuContentRef = useRef();
    const isExtraLargeDesktop = useMediaQuery({
        minWidth: BREAKPOINT_SIZES.XL.min
    });

    useEffect(() => {
        if (!menuContentRef.current) return;
        const element = menuContentRef.current.parentElement;
        const marginBottom = isExtraLargeDesktop ? 7 : 0;
        const marginTop = element.getBoundingClientRect().top;
        const marginY = marginTop + marginBottom;
        // iOS viewport height bugfix for https://bugs.webkit.org/show_bug.cgi?id=141832#c5
        const menuHeight = window.innerHeight - marginY;
        // eslint-disable-next-line better-mutation/no-mutation
        element.style.maxHeight = `${menuHeight}px`;
    }, [isExtraLargeDesktop]);
    return menuContentRef;
};
